module.exports = __webpack_public_path__ + "img/yanshi.d9efde0b.png";